// Blog.js - Blog listing page
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Blog = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  
  const blogPosts = [
    {
      id: "cleaner-tomorrow-odisha",
      title: "A Cleaner Tomorrow: Corenova's Renewable Energy Vision in Odisha",
      excerpt: "How Corenova is providing impactful renewable energy services in Odisha to meet today's demands and tomorrow's challenges.",
      date: "January 15, 2024",
      readTime: "8 min read",
      category: "renewable-energy",
      image: "/images/renewable (1).png"
    },
    {
      id: "odisha-solar-panel-installation",
      title: "Odisha Solar Panel Installation: Why This Is the Ideal Time to Invest in Solar",
      excerpt: "Discover why now is the perfect time to invest in solar energy in Odisha with government subsidies, ideal climate conditions, and long-term savings.",
      date: "April 5, 2024",
      readTime: "10 min read",
      category: "solar",
      image: "/images/solar installation.png"
    },

    {
  id: "odisha-wind-energy-solutions",
  title: "Odisha Wind Energy Solutions: Using Corenova to Drive Advancement Renewably",
  excerpt: "Discover how Odisha's wind energy potential can power sustainable development with Corenova's comprehensive wind energy solutions and expertise.",
  date: "June 12, 2024",
  readTime: "12 min read",
  category: "wind",
  image: "/images/SOLAR 1 (1).png"
}
  ];

  const categories = [
    { id: 'all', name: 'All Articles' },
    { id: 'renewable-energy', name: 'Renewable Energy' },
    { id: 'solar', name: 'Solar Power' },
    { id: 'hydro', name: 'Hydroelectric' },
    { id: 'wind', name: 'Wind Energy' },
    { id: 'community', name: 'Community Impact' },
    { id: 'impact', name: 'Economic Impact' }
  ];

  const filteredPosts = activeFilter === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === activeFilter);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Corenova Blog</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Insights, updates, and stories about renewable energy transformation in Odisha and beyond.
          </p>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setActiveFilter(category.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                activeFilter === category.id
                  ? 'bg-green-600 text-white'
                  : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Featured Post */}
        <div className="mb-16">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="h-64 md:h-auto">
                <img 
                  src={blogPosts[0].image} 
                  alt={blogPosts[0].title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 bg-green-100 text-green-800 text-sm font-medium rounded-full mb-4">
                  Featured
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  {blogPosts[0].title}
                </h2>
                <p className="text-gray-600 mb-6">
                  {blogPosts[0].excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-500">
                    {blogPosts[0].date} • {blogPosts[0].readTime}
                  </div>
                  <Link
                    to={`/blog/${blogPosts[0].id}`}
                    className="inline-flex items-center text-green-600 font-medium hover:text-green-700 transition-colors"
                  >
                    Read more
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.slice(1).map((post) => (
            <div key={post.id} className="bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col h-full">
              <div className="h-48">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {post.excerpt}
                  </p>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="text-sm text-gray-500">
                    {post.date} • {post.readTime}
                  </div>
                  <Link
                    to={`/blog/${post.id}`}
                    className="inline-flex items-center text-green-600 font-medium hover:text-green-700 transition-colors text-sm"
                  >
                    Read more
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

      
      </div>
    </div>
  );
};

export default Blog;